import HttpWrapper from '../utils/http/httpWrapper'
import ShipbobAppSettings from '../appSettings/appSetting'

class FrontEndAppSettingsInternal {
  urls () {
    return {
      getSettings: ShipbobAppSettings.frontEndAppSettings + '/api/getSettings'
    }
  }

  async getSettings () {
    const request = {
      Url: this.urls().getSettings
    }
    return await HttpWrapper.Get(request, null, null, true)
  }
}

export const FrontEndAppSettingsService = new FrontEndAppSettingsInternal()
